import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { createUserApiError } from '../../../lib/createUserApiError';
import { RestAddress } from '../fragments.rest';
import { convertAddressAttributesToRestInput } from '../convertAddressAttributesToRestInput';
import { EDIT_ADDRESS_MUTATION } from './editAddressMutation.rest';

export const useEditAddressMutation = () => {
  const [mutate, { loading, error }] = useMutation(EDIT_ADDRESS_MUTATION);
  const userApiError = createUserApiError(error);

  const editAddress = useCallback(
    async (address: RestAddress) => {
      const result = await mutate({
        variables: {
          id: address.id,
          input: convertAddressAttributesToRestInput(address.attributes)
        }
      });
      return result.data?.editAddress.data;
    },
    [mutate]
  );

  return [
    editAddress,
    {
      loading,
      error: userApiError
    }
  ] as const;
};
